<template>
  <div v-if="moveContactStage.nextStage.value" class="flex items-center gap-2">
    <ContactStageUpdateButton
      :contact="contact"
      :move-contact-stage="moveContactStage"
      @stage-selected="handleStageSelected"
    />
    <Tooltip>
      <TooltipTrigger as-child>
        <Button
          variant="ghost"
          size="icon"
          class="size-10 rounded-md border border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-red-600"
          @click="showDisqualified = true"
        >
          <vue-feather type="x" class="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Reject Candidate</p>
      </TooltipContent>
    </Tooltip>
  </div>

  <Teleport to="body">
    <MeetingStageSheet
      v-if="meetingStageTarget"
      :contact="contact"
      :contact-stage="meetingStageTarget"
      :move-contact-stage="moveContactStage"
      @stage-changed="
        meetingStageTarget = null;
        emit('stage-changed', $event);
      "
      @handle-cancel="meetingStageTarget = null"
    />
    <ContactOnboard
      v-if="showContactOnboard"
      :contact="contact"
      @handle-contact-onboard="
        showContactOnboard = false;
        emit('stage-changed', 'Onboarding');
      "
      @handle-contact-onboard-cancel="showContactOnboard = false"
    />
    <ContactDisqualify
      v-if="showDisqualified"
      :contact="contact"
      @handle-contact-disqualify="
        showDisqualified = false;
        emit('stage-changed', 'Disqualified');
      "
      @handle-contact-disqualify-cancel="showDisqualified = false"
    />
  </Teleport>
</template>

<script setup lang="ts">
import { ref, toRef } from 'vue';
import type { ContactDetail } from '../ContactDetail';
import ContactOnboard from '../ContactOnboard.vue';
import MeetingStageSheet from '../MeetingStageSheet/index.vue';
import ContactStageUpdateButton from './ContactStageUpdateButton.vue';
import { useMoveContactStage } from './useMoveContactStage';
import Button from '@/components/ui/button/Button.vue';
import ContactDisqualify from '../ContactDisqualify/index.vue';
import Tooltip from '@/components/ui/tooltip/Tooltip.vue';
import TooltipTrigger from '@/components/ui/tooltip/TooltipTrigger.vue';
import TooltipContent from '@/components/ui/tooltip/TooltipContent.vue';
import type { ContactStage } from '@/api/entity_types/Contact';

type Props = {
  contact: ContactDetail;
};
const props = defineProps<Props>();

const showContactOnboard = ref(false);
const showDisqualified = ref(false);
const meetingStageTarget = ref<ContactStage | null>(null);
const moveContactStage = useMoveContactStage(toRef(props, 'contact'));

const handleStageSelected = async (stage: ContactStage) => {
  if (stage === 'Onboarding') {
    showContactOnboard.value = true;
    return;
  }

  if (stage === 'Interview' || stage === 'Phone Screen') {
    meetingStageTarget.value = stage;
    return;
  }

  const success = await moveContactStage.updateContactStage(stage);
  if (success) emit('stage-changed', stage);
};

const emit = defineEmits<{ 'stage-changed': [newStage: ContactStage] }>();
</script>
